/**
 * Normalises a user-entered phone number to E.164. Defaults to UK (+44) when
 * the number is typed as a local number with a leading 0. Shared by the
 * sign-in page and the inline quick-sign-in block so both behave identically.
 */
export function normalisePhone(raw: string): string {
  const trimmed = raw.trim();
  if (!trimmed) return trimmed;
  if (trimmed.startsWith("+")) return trimmed.replace(/\s+/g, "");
  // Default to UK if the user types a local number without a country code.
  const digits = trimmed.replace(/[^0-9]/g, "");
  if (digits.startsWith("0")) return `+44${digits.slice(1)}`;
  return `+${digits}`;
}
